import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'

export interface CreateTxOverviewParams {
  from: Token
  to: Token
  amount: NormalizedNumber
}

export type TxOverview =
  | { status: 'no-overview' }
  | {
      status: 'success'
      from: Token
      outcome: {
        token: Token
        value: NormalizedNumber
        usdValue: NormalizedNumber
      }
    }

export function createTxOverview({ from, to, amount }: CreateTxOverviewParams): TxOverview {
  if (amount.isZero()) {
    return { status: 'no-overview' }
  }

  const outcome = {
    token: to,
    value: amount,
    usdValue: to.toUSD(amount),
  }

  return {
    status: 'success',
    from,
    outcome,
  }
}
